/**
 * Validación y normalización de enlaces Telegram públicos (CTA, admin, env).
 * Centralizado para Bio premium simple, Reels y resolución premium-invite.
 */

export function trimOutboundCtaUrl(raw: string | undefined): string {
  const t = String(raw ?? "").trim();
  if (t.length < 12) return "";
  if (!/^https?:\/\//i.test(t)) return "";
  if (/your-|tu-|example|xxx/i.test(t)) return "";
  return t;
}

/** `https://…` o `t.me/…` / `telegram.me/…` sin esquema (frecuente en admin / AR). */
export function normalizePublicOutboundUrl(raw: string): string {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return "";
  const direct = trimOutboundCtaUrl(trimmed);
  if (direct) return direct;
  let t = trimmed.replace(/^\/+/, "");
  if (!/^https?:\/\//i.test(t)) {
    if (/^(t\.me|telegram\.me|telegram\.dog)\//i.test(t)) {
      t = `https://${t}`;
    } else {
      return "";
    }
  }
  return trimOutboundCtaUrl(t);
}

const TELEGRAM_OUTBOUND_HOSTS = new Set([
  "t.me",
  "telegram.me",
  "telegram.org",
  "telegram.dog",
]);

/** true solo para https://t.me/… (u otros hosts Telegram públicos). */
export function isValidTelegramOutboundUrl(raw: string | null | undefined): boolean {
  const normalized = normalizePublicOutboundUrl(String(raw ?? "").trim());
  if (!normalized) return false;
  try {
    const u = new URL(normalized);
    if (u.protocol !== "https:") return false;
    const host = u.hostname.toLowerCase().replace(/^www\./, "");
    return TELEGRAM_OUTBOUND_HOSTS.has(host);
  } catch {
    return false;
  }
}
